export const publicPages = [
  'index',
  'login',
  'carrier-login',
  'carrier-verification',
  'carrier-blocked',
  'login-social-microsoft',
  'error',
  'register',
  'password-reset',
  'password-reset-confirm-uid-token',
  'carrier-chash-auction-hash',
  'carrier-tender-hash',
  'carrier-request-list',
  'carrier-transport-list',
  'carrier-tender-list',
  'carrier-contract-list',
  'carrier-contract-hash',
  'invitations-accept-invite-hash',
  'account-confirm-email-hash',
  'privacy-preferences-hash',
  'all',
]
